import { useMemo } from 'react';

// Clusterização leve em grade (sem libs extras). Mantém os marcadores como
// elementos HTML acessíveis (botões) e agrupa comércios próximos em baixo zoom,
// expandindo progressivamente conforme o usuário aproxima.
//
// - zoom >= CLUSTER_MAX_ZOOM: nunca agrupa (marcadores individuais);
// - a célula da grade cresce quando o zoom diminui.
const CLUSTER_MAX_ZOOM = 14;
const MIN_CLUSTER_SIZE = 4;

function clusterBusinesses(businesses, zoom) {
  if (!Array.isArray(businesses)) return [];
  if (zoom == null || zoom >= CLUSTER_MAX_ZOOM || businesses.length <= MIN_CLUSTER_SIZE) {
    return businesses.map((business) => ({ type: 'single', business }));
  }

  const step = zoom <= 10 ? 0.02 : zoom <= 12 ? 0.008 : 0.004;
  const buckets = new Map();

  businesses.forEach((business) => {
    if (business.lat == null || business.lng == null) return;
    const key = `${Math.round(business.lat / step)},${Math.round(business.lng / step)}`;
    if (!buckets.has(key)) buckets.set(key, []);
    buckets.get(key).push(business);
  });

  const result = [];
  buckets.forEach((members) => {
    if (members.length === 1) {
      result.push({ type: 'single', business: members[0] });
      return;
    }
    const lat = members.reduce((sum, b) => sum + Number(b.lat), 0) / members.length;
    const lng = members.reduce((sum, b) => sum + Number(b.lng), 0) / members.length;
    result.push({
      type: 'cluster',
      id: members.map((m) => m.id).join('-'),
      lat,
      lng,
      count: members.length,
      members,
    });
  });

  return result;
}

export function useCluster(businesses, zoom) {
  return useMemo(() => clusterBusinesses(businesses, zoom), [businesses, zoom]);
}
